import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { CreateLeadPayload } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { Input, InputSize } from "shared/components";
import { RegisterTyped } from "shared/hooks";

export const BasicInfoSection = ({
  register,
  wrapperClassName,
  isTitleDisabled = false,
  cardClassName
}: {
  register: RegisterTyped<CreateLeadPayload>;
  wrapperClassName?: string;
  isTitleDisabled?: boolean;
  cardClassName?: string;
}) => {
  return (
    <SectionCard
      title="Basic information"
      wrapperClassName={wrapperClassName}
      isTitleDisabled={isTitleDisabled}
      cardClassName={cardClassName}
    >
      <div className="flex w-full gap-4">
        <div className="w-full">
          <Input
            {...register("first_name")}
            id="firstName"
            size={InputSize.SM}
            label="First name"
            required
          />
        </div>

        <div className="w-full">
          <Input
            {...register("last_name")}
            id="lastName"
            size={InputSize.SM}
            label="Last name"
            required
          />
        </div>
      </div>
    </SectionCard>
  );
};
